import Modal from './Modal';
import { __ } from '../i18n/hub';

export type CabinetFiscalPeriodModalProps = {
  isOpen: boolean;
  onClose: () => void;
  fiscalYearStart: string;
  fiscalYearEnd: string;
  onFiscalYearStartChange: (value: string) => void;
  onFiscalYearEndChange: (value: string) => void;
  onSave: () => void;
  isSaving: boolean;
  error: string | null;
  canEdit?: boolean;
};

const CabinetFiscalPeriodModal = ({
  isOpen,
  onClose,
  fiscalYearStart,
  fiscalYearEnd,
  onFiscalYearStartChange,
  onFiscalYearEndChange,
  onSave,
  isSaving,
  error,
  canEdit = true,
}: CabinetFiscalPeriodModalProps) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={__('Période fiscale du cabinet')}
    size="small"
    testId="cabinet-fiscal-period-modal"
  >
    <p>
      {__(
        'Renseignez la période fiscale du cabinet pour démarrer la mission VS.',
      )}
    </p>

    {!canEdit ? (
      <p className="cabinet-fiscal-period-modal__notice">
        {__(
          'Seul le propriétaire de l’abonnement peut modifier la période fiscale du cabinet.',
        )}
      </p>
    ) : null}

    <div className="cabinet-fiscal-period-modal__fields">
      <label htmlFor="cabinet-fiscal-year-start">
        {__("Début d'exercice")}
        <input
          id="cabinet-fiscal-year-start"
          type="date"
          value={fiscalYearStart}
          onChange={(event) => onFiscalYearStartChange(event.target.value)}
          disabled={!canEdit || isSaving}
          required
        />
      </label>

      <label htmlFor="cabinet-fiscal-year-end">
        {__("Fin d'exercice")}
        <input
          id="cabinet-fiscal-year-end"
          type="date"
          value={fiscalYearEnd}
          onChange={(event) => onFiscalYearEndChange(event.target.value)}
          disabled={!canEdit || isSaving}
          required
        />
      </label>
    </div>

    {error !== null && error !== '' ? (
      <p className="cabinet-fiscal-period-modal__error" role="alert">
        {error}
      </p>
    ) : null}

    <div className="cabinet-fiscal-period-modal__actions mt-16">
      <button type="button" className="btn-secondary mr-8" onClick={onClose} disabled={isSaving}>
        {__('Annuler')}
      </button>
      <button
        type="button"
        className="btn-primary"
        onClick={onSave}
        disabled={!canEdit || isSaving}
      >
        {isSaving ? __('Enregistrement…') : __('Enregistrer et démarrer')}
      </button>
    </div>
  </Modal>
);

export default CabinetFiscalPeriodModal;
